import { DataValidator, IsBoolean, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api, { apiService } from "./api";

export interface KuaishouThirdAccountResponse {
  results: Array<Results>;
  sid?: string;
};

export interface Results {
  id: string;
  name?: string;
  avatar?: string;
  isExpired: boolean;
  lastPublishAt: string;
  platform: string;
};

class ResultsData {
  @Required("Id cannot be empty")
  @IsString("Id must be a string")
  id: string;

  @Required("Name cannot be empty")
  @IsBoolean("Name must be a boolean")
  isExpired?: boolean;
}

class KuaishouThirdAccountData {
  @Required("results url cannot be empty")
  results: ResultsData[];
}

const transformAndValidateData = (
  response: KuaishouThirdAccountResponse
): KuaishouThirdAccountData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, KuaishouThirdAccountData);
  } catch (error) {
    console.error("Kuaishou third account data validation failed:", error.message);
    throw error;
  }
};

// 获取快手第三方账号id
export const kuaishouThirdAccount = async () => {
  const res = await api.post<KuaishouThirdAccountResponse>("/kuaishou/third_account");
  return transformAndValidateData(res.data);
};
